import { Ano } from './ano';

/** Dados de um representante com seus KPIs */
export class Representante {
    id: number;
    codigoIntegracaoErp: string;
    cnpjCpf: string;
    nome: string;
    nomeFantasia: string;
    situacao: number;
    modalidadeComercial: number;
    anos: Ano[];

    constructor(props: Partial<Representante>) {
        Object.assign(this, props);

        if (props) {
            // Anos
            this.constructorAnos(props.anos);
        }
    }

    /** Constructor para os anos */
    private constructorAnos(anos: Ano[]) {
        if (anos && Array.isArray(anos)) {
            this.anos = anos.map(ano => new Ano(ano));
        } else {
            this.anos = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Representante {
        return new Representante(JSON.parse(json));
    }
}
